import { createAsyncThunk } from '@reduxjs/toolkit';
import { _billingUrls } from '@custom/Utils/constants/apiUrls';

interface InvestigationParams {
  hospitalId?: string;
  search?: string;
  page?: number;
  limit?: number;
}

const getInvestigationApi = createAsyncThunk(
  'getInvestigationApi',
  async (params?: InvestigationParams) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const hospitalId = params?.hospitalId || sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');

      const query = new URLSearchParams();
      if (hospitalId) query.append('hospitalId', hospitalId);
      if (params?.search) query.append('search', params.search);
      if (params?.page !== undefined) query.append('page', String(params.page));
      if (params?.limit !== undefined) query.append('limit', String(params.limit));

      const url = `${_billingUrls.getInvestigation}?${query.toString()}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch package details');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

export default getInvestigationApi;
